/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

const DEFAULT_ADAPTIVE_SCALE_STEP = 5;

function isFiniteNumber(value: number): boolean {
  return Number.isFinite(value);
}

export function getObservedKpiMin(currentValue: number, trendValues: number[] = []): number {
  const finiteTrendValues = trendValues.filter(isFiniteNumber);
  if (!isFiniteNumber(currentValue)) {
    return finiteTrendValues.length ? Math.min(...finiteTrendValues) : currentValue;
  }
  return finiteTrendValues.length ? Math.min(currentValue, ...finiteTrendValues) : currentValue;
}

export function getAdaptiveScaleMin(
  observedMin: number,
  configuredMin: number,
  step: number = DEFAULT_ADAPTIVE_SCALE_STEP,
): number {
  if (!Number.isFinite(configuredMin)) {
    return configuredMin;
  }
  if (!Number.isFinite(observedMin) || observedMin >= configuredMin) {
    return configuredMin;
  }

  const safeStep = Number.isFinite(step) && step > 0 ? step : DEFAULT_ADAPTIVE_SCALE_STEP;
  // Use the next lower bucket (strictly below observed minimum) to keep points visible.
  const bucketMin = Math.max(0, Math.floor((observedMin - 1e-6) / safeStep) * safeStep);
  return Math.min(configuredMin, bucketMin);
}
